import { Component, EventEmitter, Input, Output, inject, signal } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NavigationEnd, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { navItems, NavItem, ItemActions, SubItem, ItemActionOrNavigation} from '../static/nav-items';
import { filter } from 'rxjs';
import { ICONS } from '../static/icons';
import { VentasSidebarService } from '@ribera-web/ventas-data-access';
import { NavigationActionService } from '../static/navigation-action.service';

@Component({
  selector: 'lib-sidebar',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive],
  templateUrl: './sidebar.html',
  styleUrl: './sidebar.scss',
})
export class Sidebar {
  @Input() isOpen = false;
  @Input() activeItem = 'dashboard';
  @Output() navClick = new EventEmitter<string>();
  @Output() logoutClick = new EventEmitter<void>();

  private sanitizer = inject(DomSanitizer);
  private router = inject(Router);
  private location = inject(Location);
  ventasSidebarService = inject(VentasSidebarService);
  navitationActionsService = inject(NavigationActionService);

  title = signal('general'.toUpperCase());
  activeModule = signal<NavItem | null>(null);
  itemsActions = signal<ItemActions[]>([]);

  constructor() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ).subscribe((event: any) => {
      const currentUrl = event.urlAfterRedirects;
      // console.log('currentUrl', currentUrl);
      const targetModule = this.navItems().find(modulo => 
        currentUrl.startsWith(modulo.path) && modulo.subItems != undefined && modulo.subItems.length > 0
      );

      this.title.set(targetModule ? targetModule.label.toUpperCase() : 'GENERAL');
      // console.log('targetModule', targetModule);
      this.activeModule.set(targetModule || null);
      // this.activeItem = targetModule && targetModule.subItems ? targetModule.subItems[0].id : 'dashboard';
      // console.log('this.activeItem', this.activeItem);
    });

  }

  navItems = signal<NavItem[]>(navItems);

  navigateItem(item: NavItem) {
    if (item.subItems && item.subItems.length > 0) {
      console.log('item.itemsActions 1');
      this.router.navigate([item.subItems[0].path]);
      this.activeModule.set(item);
      this.activeItem = item.subItems[0].id;

      return;
    }
    this.activeItem = item.id;
    this.router.navigate([item.path]);
  }

  navigateSubItemActions(item: SubItem) {
    if (item.itemsActions && item.itemsActions.length > 0) {
      console.log('item.itemsActions 2');
      this.itemsActions.set(item.itemsActions);
      this.router.navigate([item.path]);
      return;
    }
    this.activeItem = item.id;
    this.router.navigate([item.path]);
  }

  isActive(id: string): boolean {
    return this.activeItem === id;
  }

  onNavClick(id: string): void {
    this.navClick.emit(id);
  }

  onLogout(): void {
    this.logoutClick.emit();
  }

  getIcon(icon: string): SafeHtml {
    const icons: Record<string, string> = ICONS
    return this.sanitizer.bypassSecurityTrustHtml(icons[icon] ?? '');
  }

  onContextItemClick(item: ItemActions): void {
    console.log('ActionsItems', item);
    this.activeItem = item.id;
    this.ventasSidebarService.contextItemClick$.next(item.id);
  }

  onClosePago(): void {
    this.ventasSidebarService.closePago$.next();
  }

  onVolverVentas(): void {
    const currentUrl = this.router.url;
    this.ventasSidebarService.volverClick$.next();

    if (currentUrl.includes('/ventas/venta-rapida') || currentUrl.includes('/ventas/venta-manual')) {
      void this.router.navigate(['/ventas/por-salon']);
    }
  }

  onAnularVentaClick(): void {
    this.ventasSidebarService.anularVentaClick$.next();
  }

  return(){
    console.log('return');
    this.activeItem = 'dashboard';
    this.router.navigate(['/dashboard']);
    // this.location.back();
  }

  returnActions(){
    this.itemsActions.set([]);
  }

  returnActionsToComponent(){    
    this.location.back();
  }

  selectedAction(item: ItemActionOrNavigation): void {
    if (item.type === 'navigation' && item.path) {
      this.router.navigateByUrl(item.path);
      return;
    }
    this.navitationActionsService.selectAction(item.id);
  }

  isActiveNavigationOrAction(item: ItemActionOrNavigation): boolean {
    if ( item.type === 'navigation' && item.path){
      return this.router.isActive(item.path, {
        paths: 'exact',
        queryParams: 'exact',
        fragment: 'exact',
        matrixParams: 'exact'
      });
    }

    return false;
  }
}
